import React, { memo } from 'react';

import { ReactComponent as OnCallBadgeIcon } from '../../assets/images/on-call-badge-icon.svg';
import { ReactComponent as MarkedAsCallbackBadgeIcon } from '../../assets/images/marked-as-callback-badge-icon.svg';
import { ReactComponent as CallbackShiftBadgeIcon } from '../../assets/images/callback-shift-badge-icon.svg';

import './OnCallBadge.css';

const OnCallSlotBadge = ({ slot }) => {
	if (!slot) {
		return null;
	}

	// if on-call slot is not marked as called back, we show the on-call badge
	const isOnCall = slot.is_on_call && !slot.marked_as_callback;
	// if on-call slot is marked as called back, we show the marked as called back badge
	const isMarkedAsCalledBack = slot.is_on_call && slot.marked_as_callback;
	// if slot is callback, we show the callback badge
	const isCallback = !!slot.on_call_slot_id;

	return (
		<div className="on-call-badge">
			<span className="on-call-badge__icon">
				{isOnCall && <OnCallBadgeIcon />}
				{isMarkedAsCalledBack && <MarkedAsCallbackBadgeIcon />}
				{isCallback && <CallbackShiftBadgeIcon />}
			</span>
			<span className="on-call-badge__label">
				{isOnCall && 'On Call shift'}
				{isMarkedAsCalledBack && 'Marked as Called Back'}
				{isCallback && 'Callback shift'}
			</span>
		</div>
	);
};

export default memo(OnCallSlotBadge);
